import React from 'react';
import { CheckIcon } from '@heroicons/react/24/outline';

export default function SetupCompleteModal({ isOpen, onGoToDashboard, onTestAssistant, onViewDeployment }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white max-w-lg w-full mx-4 rounded-2xl p-10 text-center">
        {/* Green checkmark */}
        <div className="mx-auto w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-6">
          <CheckIcon className="h-8 w-8 text-green-600" />
        </div>

        {/* Headline */}
        <h2 className="text-2xl font-bold text-gray-900 font-arsenal mb-3">
          Setup Complete! Your AI Assistant is Ready.
        </h2>

        {/* Body */}
        <p className="text-gray-600 font-source mb-8">
          We've processed your data and secured your widget domains.
        </p>

        {/* Primary CTA */}
        <button
          onClick={onGoToDashboard}
          className="w-full px-6 py-3 bg-cleona-600 text-white rounded-lg hover:bg-cleona-700 transition-colors font-medium font-source mb-3"
        >
          Go to Dashboard
        </button>

        {/* Secondary CTA */}
        <button
          onClick={onTestAssistant}
          className="w-full px-6 py-3 border border-cleona-600 text-cleona-600 rounded-lg hover:bg-cleona-50 transition-colors font-medium font-source mb-3"
        >
          Test My Assistant
        </button>

        {/* Link-style button */}
        <button
          onClick={onViewDeployment}
          className="text-sm text-gray-500 hover:text-cleona-600 transition-colors font-source underline"
        >
          View Deployment Instructions
        </button>
      </div>
    </div>
  );
}
